import React, { useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Box
} from "@mui/material";
import CustomDateField from "./CustomDateField";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const CustomsValuationFilterDialog = ({ open, onClose, handleSearch, initialFilters }) => {
  const [formData, setFormData] = useState({
    declareCls: "",
    judge: "",
    firstImportFrom: "",
    firstImportTo: "",
    importDeclarationNo: "",
    importDeclarationFrom: "",
    importDeclarationTo: "",
    createdMonthFrom: "",
    createdMonthTo: "",
    pic: "",
    section: "",
    makerPartNo: "",
    makerPartNo2: "",
    makerPartNo3: "",
    keywordOneCheck: "",
    keywordTwoCheck: "",
    reasonForNoDeclareCls: "",
    remarks: "",
    invoiceNo: "",
    shipNoSoNo: "",
    itemCode: "",
    project: "",
    confirmationStatus: ""
  });

  // When the dialog opens or initialFilters change, populate formData
  useEffect(() => {
    if (open && Array.isArray(initialFilters) && initialFilters.length > 0) {
      const newForm = {
        declareCls: "",
        judge: "",
        firstImportFrom: "",
        firstImportTo: "",
        importDeclarationNo: "",
        importDeclarationFrom: "",
        importDeclarationTo: "",
        createdMonthFrom: "",
        createdMonthTo: "",
        pic: "",
        section: "",
        makerPartNo: "",
        makerPartNo2: "",
        makerPartNo3: "",
        keywordOneCheck: "",
        keywordTwoCheck: "",
        reasonForNoDeclareCls: "",
        remarks: "",
        invoiceNo: "",
        shipNoSoNo: "",
        itemCode: "",
        project: "",
        confirmationStatus: ""
      };

      initialFilters.forEach(f => {
        if (f && f.columnField) {
          // some saved filters may use 'entity.erpEntityCode' key – skip here
          newForm[f.columnField] = f.value;
        }
      });

      setFormData(newForm);
    }
  }, [open, initialFilters]);

  const handleClear = () => {
    setFormData({
      declareCls: "",
      judge: "",
      firstImportFrom: "",
      firstImportTo: "",
      importDeclarationNo: "",
      importDeclarationFrom: "",
      importDeclarationTo: "",
      createdMonthFrom: "",
      createdMonthTo: "",
      pic: "",
      section: "",
      makerPartNo: "",
      makerPartNo2: "",
      makerPartNo3: "",
      keywordOneCheck: "",
      keywordTwoCheck: "",
      reasonForNoDeclareCls: "",
      remarks: "",
      invoiceNo: "",
      shipNoSoNo: "",
      itemCode: "",
      project: "",
      confirmationStatus: ""
    });
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogTitle sx={{ fontWeight: "bold" }}>
        Customs Valuation Filters
      </DialogTitle>
      <DialogContent
        sx={{
          width: "620px",
          padding: 2,
          maxHeight: "70vh",
          overflowY: "auto"
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.necessaryOrUnnecessary"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <FormControl
              fullWidth
              size="small"
              sx={{ width: "150px", height: 36 }}
            >
              <Select
                value={formData.declareCls}
                onChange={e => handleChange("declareCls", e.target.value)}
                displayEmpty
                inputProps={{ sx: { height: 36 } }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="NULL">NULL (空白)</MenuItem>
                <MenuItem value="01">要</MenuItem>
                <MenuItem value="00">不要</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.judge"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }} // 👈 controlled width
              InputProps={{ sx: { height: 36 } }}
              value={formData.judge}
              onChange={e => handleChange("judge", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.firstImportStartDate"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <CustomDateField
              placeholder="First Import Date From"
              value={formData.firstImportFrom}
              onChange={val => handleChange("firstImportFrom", val)}
              width="300px"
              height="36px"
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.firstImportEndDate"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <CustomDateField
              placeholder="First Import Date To"
              value={formData.firstImportTo}
              onChange={val => handleChange("firstImportTo", val)}
              width="300px"
              height="36px"
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.importDeclarationNo"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.importDeclarationNo}
              onChange={e =>
                handleChange("importDeclarationNo", e.target.value)
              }
            />
          </Grid>
          {/* <Grid item xs={6} /> */}
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.importDeclarationStartDate"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <CustomDateField
              placeholder="importDeclarationFrom"
              value={formData.importDeclarationFrom}
              onChange={val => handleChange("importDeclarationFrom", val)}
              width="300px"
              height="36px"
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.importDeclarationEndDate"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <CustomDateField
              placeholder="importDeclarationTo"
              value={formData.importDeclarationTo}
              onChange={val => handleChange("importDeclarationTo", val)}
              width="300px"
              height="36px"
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.intakeStartMonth"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <CustomDateField
              placeholder="createdMonthFrom"
              value={formData.createdMonthFrom}
              onChange={val => handleChange("createdMonthFrom", val)}
              width="300px"
              height="36px"
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.intakeEndMonth"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <CustomDateField
              placeholder="createdMonthTo"
              value={formData.createdMonthTo}
              onChange={val => handleChange("createdMonthTo", val)}
              width="300px"
              height="36px"
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.personInCharge"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.pic}
              onChange={e => handleChange("pic", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.section"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.section}
              onChange={e => handleChange("section", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.makerPartNo"
                defaultMessage="Maker Part No"
              />
            </label>
          </Grid>
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.makerPartNo}
              onChange={e => handleChange("makerPartNo", e.target.value)}
            />
          </Grid>
          <Grid item xs={2} /> {/* Empty label space */}
          <Grid item xs={9}>
            <Box
              sx={{
                width: "150px",
                margin: "0 auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.keywordOneCheck === "AND"}
                    onChange={() =>
                      handleChange(
                        "keywordOneCheck",
                        formData.keywordOneCheck === "AND" ? "" : "AND"
                      )
                    }
                  />
                }
                label="AND"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.keywordOneCheck === "OR"}
                    onChange={() =>
                      handleChange(
                        "keywordOneCheck",
                        formData.keywordOneCheck === "OR" ? "" : "OR"
                      )
                    }
                  />
                }
                label="OR"
              />
            </Box>
          </Grid>
          {/* Keyword 2 */}
          <Grid item xs={3} />
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.makerPartNo2}
              onChange={e => handleChange("makerPartNo2", e.target.value)}
            />
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={9}>
            <Box
              sx={{
                width: "150px",
                margin: "0 auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.keywordTwoCheck === "AND"}
                    onChange={() =>
                      handleChange(
                        "keywordTwoCheck",
                        formData.keywordTwoCheck === "AND" ? "" : "AND"
                      )
                    }
                  />
                }
                label="AND"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.keywordTwoCheck === "OR"}
                    onChange={() =>
                      handleChange(
                        "keywordTwoCheck",
                        formData.keywordTwoCheck === "OR" ? "" : "OR"
                      )
                    }
                  />
                }
                label="OR"
              />
            </Box>
          </Grid>
          {/* Keyword 3 */}
          <Grid item xs={3} />
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.makerPartNo3}
              onChange={e => handleChange("makerPartNo3", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.ReasonForNotReqd"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <FormControl
              fullWidth
              size="small"
              sx={{ width: "300px", height: 36 }}
            >
              <Select
                value={formData.reasonForNoDeclareCls}
                onChange={e =>
                  handleChange("reasonForNoDeclareCls", e.target.value)
                }
                displayEmpty
                inputProps={{ sx: { height: 36 } }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="NULL">NULL (空白)</MenuItem>
                <MenuItem value="通常有償出荷物で輸入は無い">
                  通常有償出荷物で輸入は無い
                </MenuItem>
                <MenuItem value="無償出荷物だが、この貨物を使用して製造した製品の輸入は無い">
                  無償出荷物だが、この貨物を使用して製造した製品の輸入は無い
                </MenuItem>
                <MenuItem value="国内取引であり輸入は無い">
                  国内取引であり輸入は無い
                </MenuItem>
                <MenuItem value="三国間取引であり輸入は無い">
                  三国間取引であり輸入は無い
                </MenuItem>
                <MenuItem value="返品処理で輸入は無い">
                  返品処理で輸入は無い
                </MenuItem>
                <MenuItem value="通常の輸入貨物">通常の輸入貨物</MenuItem>
                <MenuItem value="インボイス価格に含まれているので評価申告は不要">
                  インボイス価格に含まれているので評価申告は不要
                </MenuItem>
                <MenuItem value="その他（詳細理由記載＆輸入に関わる費用か否かを記載）">
                  その他（詳細理由記載＆輸入に関わる費用か否かを記載）
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.remarks"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.remarks}
              onChange={e => handleChange("remarks", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageFilter.invoiceNo"
                defaultMessage="invoice No"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.invoiceNo}
              onChange={e => handleChange("invoiceNo", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.ShipNo/SoNo"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.shipNoSoNo}
              onChange={e => handleChange("shipNoSoNo", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.lineItemCode.label"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.itemCode}
              onChange={e => handleChange("itemCode", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageFilter.project"
                defaultMessage="Section"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: "300px", height: 36 }}
              InputProps={{ sx: { height: 36 } }}
              value={formData.project}
              onChange={e => handleChange("project", e.target.value)}
            />
          </Grid>
          <Grid item xs={3}>
            <label style={{ fontSize: 14 }}>
              <FormattedMessage
                id="columnname.messageNumber.inputCheckField"
                defaultMessage="Input Check Field"
              />
            </label>
          </Grid>
          {/* Input box on the right */}
          <Grid item xs={9}>
            <FormControl
              fullWidth
              size="small"
              sx={{ width: "150px", height: 36 }}
            >
              <Select
                value={formData.confirmationStatus}
                onChange={e =>
                  handleChange("confirmationStatus", e.target.value)
                }
                displayEmpty
                inputProps={{ sx: { height: 36 } }}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value="Confirmed">Confirmed</MenuItem>
                <MenuItem value="Not-Confirmed">Not-Confirmed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClear} color="secondary">
          Clear
        </Button>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleSearch(formData); // 🔁 Send formData back to parent
            onClose(); // ✅ Close the dialog
          }}
        >
          Search
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomsValuationFilterDialog;
